<template>
    <tr class="entity-row-cs-36" v-if="!isDeleted">
        <td>

            <router-link :to="{ name: 'door-maintenance-report-view-item', params: {id: door.site_door_maintenance_report_item_id} }" class="d-block">
                {{ door.door_identifier }} | {{ door.door_location }} </router-link>
        </td>
        <td>
            <router-link :to="{ name: 'door-maintenance-report-view-item', params: {id: door.site_door_maintenance_report_item_id} }" class="a-primary d-block">
                View </router-link>
        </td>
        <td>
            <router-link :to="{ name: 'door-maintenance-report-edit-item', params: {id: door.site_door_maintenance_report_item_id} }"  class="a-info d-block">Edit</router-link>
        </td>
        <td>
            <a class="a-positive d-block"
               v-bind:href="'#clone-door-link-' + door.site_door_maintenance_report_item_id"
               v-bind:id="'clone-door-link-' + door.site_door_maintenance_report_item_id"
               v-on:click="cloneDoor"
               ref="cloneButton"
            >
                Clone Door</a>
        </td>
        <td>
            <a class="a-danger delete-entity d-block"
               v-bind:href="'#delete-door-link-' + door.site_door_maintenance_report_item_id"
               v-bind:id="'delete-door-link-' + door.site_door_maintenance_report_item_id"
               v-on:click="deleteDoor"
               ref="deleteButton"
            >Delete</a>
        </td>
    </tr>
</template>
<script>
    export default {
        props: ['door'],
        data() {
            return {
                isDeleted: false,
                doorToDelete: null,
                doorToClone: null,
            }
        },
        methods: {
            deleteDoor() {
                if (!window.indexedDB) {
                    window.alert("Your browser doesn't support a stable version of IndexedDB.")
                }

                var db;
                var dbName = this.getCmsDetails('dbname');
                var request = window.indexedDB.open(dbName, this.dbVersionNumber);

                request.onerror = function (event) {
                    console.log("error: ");
                };

                var vmt = this;
                request.onsuccess = function (event) {
                    db = request.result;

                    var vm = vmt;
                    try {
                        var objectStore = db.transaction('door_maintenance_report_items').objectStore('door_maintenance_report_items');
                        var storeRequest = objectStore.get(vmt.door.site_door_maintenance_report_item_id);

                        storeRequest.onsuccess = function(event) {
                            vm.doorToDelete = storeRequest.result;
                            vm.doorToDelete.is_deleted = true;

                            vm.$swal({
                                title: 'Are you sure?',
                                text: 'Are you sure you want to delete this door?',
                                type: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: '#DD6B55',
                                confirmButtonText: 'Yes',
                                closeOnConfirm: false,
                                showLoaderOnConfirm: true,
                                buttons: {
                                    cancel: {
                                        text: 'Cancel',
                                        value: null,
                                        visible: false,
                                        className: 'btn btn-square btn-sm btn-secondary',
                                        closeModal: true,
                                    },
                                    confirm: {
                                        text: 'Yes',
                                        value: true,
                                        visible: true,
                                        className: 'btn btn-square btn-sm btn-primary',
                                        closeModal: true
                                    }
                                }
                            }).then((result) => {
                                if (result.value) {
                                    var putRequest = db.transaction('door_maintenance_report_items', 'readwrite')
                                        .objectStore('door_maintenance_report_items').put(vm.doorToDelete);
                                    putRequest.onsuccess = function(event) {
                                        vm.isDeleted = true;
                                    };
                                    putRequest.onerror = function(event) {
                                        console.log(event);
                                    };
                                }
                            });
                        };
                        storeRequest.onerror = function(e) {
                            console.log(e)
                        }
                    } catch(e) {
                        console.log(e);
                    }
                };

                request.onupgradeneeded = function (event) {
                    var db = event.target.result;
                };
            },
            cloneDoor() {
                if (!window.indexedDB) {
                    window.alert("Your browser doesn't support a stable version of IndexedDB.")
                }

                var db;
                var dbName = this.getCmsDetails('dbname');
                var request = window.indexedDB.open(dbName, this.dbVersionNumber);

                request.onerror = function (event) {
                    console.log("error: ");
                };

                var vmt = this;
                request.onsuccess = function (event) {
                    db = request.result;

                    var vm = vmt;
                    try {
                        var objectStore = db.transaction('door_maintenance_report_items').objectStore('door_maintenance_report_items');
                        var storeRequest = objectStore.get(vmt.door.site_door_maintenance_report_item_id);

                        storeRequest.onsuccess = function(event) {
                            vm.doorToClone = storeRequest.result;
                            vm.doorToClone.door_identifier = storeRequest.result.door_identifier + ' ( clone )';
                            vm.doorToClone.door_maintenance_report_item_images = [];
                            vm.doorToClone.offline_images = [];
                            vm.doorToClone.site_door_maintenance_report_item_id = Math.floor(new Date().getTime() / 1000);

                            vm.$swal({
                                title: 'Are you sure?',
                                text: 'Are you sure you want to clone this door?',
                                type: 'info',
                                showCancelButton: true,
                                confirmButtonColor: '#DD6B55',
                                confirmButtonText: 'Yes',
                                closeOnConfirm: false,
                                showLoaderOnConfirm: true,
                                buttons: {
                                    cancel: {
                                        text: 'Cancel',
                                        value: null,
                                        visible: false,
                                        className: 'btn btn-square btn-sm btn-secondary',
                                        closeModal: true,
                                    },
                                    confirm: {
                                        text: 'Yes',
                                        value: true,
                                        visible: true,
                                        className: 'btn btn-square btn-sm btn-primary',
                                        closeModal: true
                                    }
                                }
                            }).then((result) => {
                                if (result.value) {
                                    var putRequest = db.transaction('door_maintenance_report_items', 'readwrite')
                                        .objectStore('door_maintenance_report_items').put(vm.doorToClone);
                                    putRequest.onsuccess = function(event) {
                                       vm.reload();
                                    };
                                    putRequest.onerror = function(event) {
                                        console.log(event);
                                    };
                                }
                            });
                        };
                        storeRequest.onerror = function(e) {
                            console.log(e)
                        }
                    } catch(e) {
                        console.log(e);
                    }
                };

                request.onupgradeneeded = function (event) {
                    var db = event.target.result;
                };


            },
            reload() {
                window.location = '';
            }
        }
    }
</script>